import {Component} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {GraphServiceService } from '../../../../../services/graph-service.service';
import { CrmService } from '../../../../../services/api/crm.service';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertService } from '../../../../../services/notify/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { catchError, EMPTY, from, Observable, switchMap } from 'rxjs';
import { TFormState } from '../../../../../models/forms.model';
import { Node}  from '../../../../../modules/graph-konva/models/graph-kn.cm-api-models';

@Component({
    selector: 'task-node-create-edge-form',
    templateUrl: './task-node-create-edge-form.html',
    styleUrl: './task-node-create-edge-form.scss'
})
export class AppTaskEdgeCreateFormComponent {
	public formState:TFormState = 'Default'
	public boardAlias:string = ''
	public source_id:string|undefined = undefined
	public createEdgeForm: FormGroup|undefined = undefined
    public nodesForConnection:Node[] = []
	constructor(
		public graphService: GraphServiceService,
		public crmService: CrmService,
		public alertService: AlertService,
		public translateService: TranslateService,
		private fb: FormBuilder,
		private dialogRef:MatDialogRef<AppTaskEdgeCreateFormComponent>
	) {}
    
	ngOnInit(): void {
        this.nodesForConnection = this.graphService.nodes.filter(el => el.bp_status_data?.is_archive !==true && el.bp_status_data?.is_universal !== true);
		this.boardAlias = this.graphService.optionBoard.alias
		this.createEdgeForm = this.fb.group({
			target_id:[null,{validators: [Validators.required]}],
			source_id: [this.source_id,{validators: [Validators.required]}],
		})
	}

	createNewEdge() {
		this.formState = 'Submitting'
		this.crmService.addEdge(this.boardAlias, this.createEdgeForm?.value)
		.pipe(
			switchMap(data=>from(this.graphService.selectBoard(data.board, true))),
			catchError(error=>this.errorHandler(error)))
		.subscribe(data=> {
			this.formState = 'Default';
			this.dialogRef.close()
			this.alertService.setAlert(this.translateService.instant('ALERTS.SUCCESS'), 'nd_color');
		})
	}

    errorHandler(error:{message:string}):Observable<never> {
		this.formState = 'Default';
		this.alertService.setAlert(error.message, 'blue');
		return EMPTY
	}

	get sourceId()  {return this.createEdgeForm?.get('source_id')}
	get targetId()  {return this.createEdgeForm?.get('target_id')}
}